import React, { useEffect, useState } from "react";
import { Search, Calendar, MapPin, Phone, Mail, MessageSquare } from "lucide-react";

const ConsultingQueries = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("https://luxuriyahomes.com/api/consultation/all")
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((err) => console.error(err));
  }, []);

  // Filter Logic
  const filteredData = data.filter((item: any) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen text-white font-[Serif]">
      
      {/* HEADER & SEARCH */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="text-3xl font-light">Consulting Requests</h2>
          <p className="text-zinc-500 text-sm mt-1">Manage interior design consultation bookings</p>
        </div>
        
        {/* Search Bar */}
        <div className="relative">
          <Search className="absolute left-3 top-3 text-zinc-500" size={18} />
          <input 
            type="text" 
            placeholder="Search by Name or Email..." 
            className="bg-[#1c1c1c] border border-zinc-800 text-white pl-10 pr-4 py-2.5 rounded-full w-full md:w-80 focus:outline-none focus:border-amber-500 transition-colors text-sm"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* DATA TABLE / CARDS */}
      {loading ? (
        <div className="text-center py-20 text-zinc-500 animate-pulse">Loading Records...</div>
      ) : (
        <div className="bg-[#1c1c1c] border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl">
          
          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-zinc-900 text-zinc-500 text-xs uppercase tracking-wider font-bold">
                <tr>
                  <th className="p-5">Date</th>
                  <th className="p-5">Client Name</th>
                  <th className="p-5">Contact Info</th>
                  <th className="p-5">Location</th>
                  <th className="p-5 text-center">WhatsApp</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800">
                {filteredData.map((item: any) => (
                  <tr key={item.id} className="hover:bg-zinc-800/30 transition-colors group">
                    <td className="p-5 text-zinc-400 text-sm whitespace-nowrap">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </td>
                    <td className="p-5">
                      <p className="font-bold text-white text-base">{item.name}</p>
                    </td>
                    <td className="p-5">
                      <div className="flex flex-col gap-1 text-sm">
                        <span className="flex items-center gap-2 text-zinc-300"><Mail size={12} className="text-amber-500"/> {item.email}</span>
                        <span className="flex items-center gap-2 text-zinc-400"><Phone size={12} className="text-amber-500"/> {item.phone}</span>
                      </div>
                    </td>
                    <td className="p-5">
                      <span className="flex items-center gap-2 text-zinc-300 bg-zinc-900 w-fit px-3 py-1 rounded-full text-xs border border-zinc-800">
                        <MapPin size={12} className="text-emerald-400"/> {item.city}
                      </span>
                    </td>
                    <td className="p-5 text-center">
                      {item.whatsappOptIn ? (
                        <span className="text-[10px] bg-green-500/10 text-green-400 border border-green-500/20 px-2 py-1 rounded font-bold uppercase tracking-wide">
                          Opted In
                        </span>
                      ) : (
                        <span className="text-[10px] text-zinc-600 uppercase font-bold tracking-wide">No</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden divide-y divide-zinc-800">
             {filteredData.map((item: any) => (
               <div key={item.id} className="p-5 space-y-3">
                 <div className="flex justify-between items-start">
                   <div>
                     <h3 className="text-lg font-bold text-white">{item.name}</h3>
                     <p className="text-xs text-zinc-500 flex items-center gap-1 mt-1">
                       <Calendar size={12}/> {new Date(item.createdAt).toLocaleDateString()}
                     </p>
                   </div>
                   <span className="bg-zinc-900 text-zinc-300 text-xs px-2 py-1 rounded border border-zinc-800">
                     {item.city}
                   </span>
                 </div>
                 
                 <div className="grid grid-cols-1 gap-2 text-sm bg-zinc-900/50 p-3 rounded-lg border border-zinc-800/50">
                    <p className="flex items-center gap-2 text-zinc-300"><Mail size={14} className="text-amber-500"/> {item.email}</p>
                    <p className="flex items-center gap-2 text-zinc-300"><Phone size={14} className="text-amber-500"/> {item.phone}</p>
                 </div>
               </div>
             ))}
          </div>

          {filteredData.length === 0 && (
            <div className="p-10 text-center text-zinc-500">No records found matching your search.</div>
          )}

        </div>
      )}
    </div>
  );
};

export default ConsultingQueries;